import { Outlet } from 'react-router'

const ActivityMainLayout = () => {
  return (
    <Outlet />
  )
}

export default ActivityMainLayout